import { Chip, Collapse, Stack, Typography, Button, Box, Grid, Divider, CardActionArea, IconButton } from '@mui/material';
import MainCard from './MainCard';
import CircleIcon from '@mui/icons-material/Circle';
import useMain from 'hooks/useMain';
import { useRef, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { detailsWorkflowFields } from 'pages/module/field';
import { useData } from 'pages/module/hook/useData';
import CusListLabelField from './CusListLabelField';
import { Button1, Button2 } from './Button';
import ModeIcon from '@mui/icons-material/Mode';
import ViewTimelineOutlinedIcon from '@mui/icons-material/ViewTimelineOutlined';
import RestoreIcon from '@mui/icons-material/Restore';
import { STEPCODE } from 'pages/module/constant';
import _ from 'lodash';
import { useSelector } from 'react-redux';

const CusDetailCard = ({ data, details, isCompleted, setOpenSidebar, setCurrentStepCode, allDisabled = false, handleViewAuditTrail }) => {
  const {
    categoryOptions,
    subCategoryOptions,
    blockOptions,
    concreteOptions,
    floorOptions,
    unitOptions,
    selectedRegion,
    selectedRoom,
    setSelectedRoom,
    selectedFloor,
    targetTypeSteps,
    supplierOptions,
    currentBctype,
    setSelectedFloor,
    setSelectedRegion,
    isLoading,
    setLoading,
    rsCompanyOptions
  } = useData({});

  const sidebarFormRef = useRef(null);
  const [preview, setPreview] = useState(false);
  const [disabled, setDisabled] = useState(allDisabled);
  const { upperCaseLang, t } = useMain();
  const project = useSelector((state) => state.auth.project);

  const theme = useTheme();

  const fields = detailsWorkflowFields({
    t,

    type: data?.Bctpye,
    stepCode: data?.Step,
    portion: data?.Portion,
    categoryOptions,
    rsCompanyOptions,
    subCategoryOptions,
    concreteOptions,
    blockOptions,
    floorOptions,
    unitOptions,
    supplierOptions,
    selectedRoom,
    setSelectedRegion,
    setSelectedFloor,
    setSelectedRoom,
    selectedRegion,
    selectedFloor,
    upperCaseLang,
    preview,
    disposed: details?.Dispose,
    setValue: sidebarFormRef.current?.setValue,
    project: project
  }).filter(({ id }) => {
    return data?.AllowField.findIndex((af) => id?.includes(af)) >= 0;
  });

  //
  //
  const displayDetailFields = (stepCode, fields) => {
    if (
      _.isEqual(stepCode, STEPCODE.MIC10) ||
      _.isEqual(stepCode, STEPCODE.ALW10) ||
      _.isEqual(stepCode, STEPCODE.TID10) ||
      _.isEqual(stepCode, STEPCODE.STA10) ||
      _.isEqual(stepCode, STEPCODE.MEG10) ||
      _.isEqual(stepCode, STEPCODE.PCF10) ||
      _.isEqual(stepCode, STEPCODE.VPB10) ||
      _.isEqual(stepCode, STEPCODE.VPK10)
    ) {
      return _.filter(fields, ({ id }) => !_.isEqual(id, 'WorkingNo'));
    }
    return fields;
  };
  //
  const header = () => {
    return (
      <Stack direction="row" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={1}>
          <Divider sx={{ borderWidth: 2, height: '25px' }} />
          <Typography color="white">{data[`StepDesc${upperCaseLang}`]}</Typography>
          <Chip
            icon={<CircleIcon style={{ color: isCompleted ? theme.palette.primary.darker : '#dd503f', fontSize: '10px' }} />}
            label={<Typography variant="body2">{isCompleted ? t('IS_COMPLETED') : t('INCOMPLETED')}</Typography>}
            size="small"
            sx={{
              backgroundColor: isCompleted ? '#e4f4eb' : '#fff1f0',
              color: isCompleted ? theme.palette.primary.darker : '#dd503f',
              borderRadius: '10px'
            }}
          />
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          {details?.Dispose > 0 ||
            (data?.CanUpdate ? (
              <IconButton
                sx={{
                  svg: {
                    color: 'white'
                  }
                }}
                onClick={() => {
                  setPreview(!data?.CanUpdate);
                  !_.isEmpty(data) && setOpenSidebar(true);
                  setCurrentStepCode(data.Step);
                }}
              >
                <ModeIcon />
              </IconButton>
            ) : (
              <></>
            ))}
          <IconButton
            sx={{
              svg: {
                color: 'white'
              }
            }}
            onClick={() => {
              handleViewAuditTrail(data?.Step);

              // setShowAuditTrails(true)
              // setOpenSidebar(true)
            }}
            disabled={_.isEmpty(data)}
          >
            <RestoreIcon />
          </IconButton>
        </Stack>
      </Stack>
    );
  };
  return (
    // <CardActionArea
    //   onClick={() => {
    //     // _handleEdit({ Step: data.Step, Portion: data.Portion, AllowField: data.AllowField }, data?.CanUpdate);
    //     // _handleEdit(data);
    //
    //     // _.map(targetTypeSteps, (value) => {
    //     //   if (_.isEqual(value?.Step, data?.Step)) {
    //     //     // document.getElementById(`${data?.Step}-detailCard-main-id`).style.borderColor = theme.palette.primary[400]
    //     //     Object.assign(document.getElementById(`${data?.Step}-detailCard-main-id`).style, {
    //     //       borderColor: theme.palette.primary[400],
    //     //       borderWidth: '3px'
    //     //     });
    //     //   } else {
    //     //     Object.assign(document.getElementById(`${value?.Step}-detailCard-main-id`).style, { borderColor: '', borderWidth: '' });
    //     //   }
    //     // });
    //   }}
    //   sx={{
    //     '& .MuiCardActionArea-focusHighlight': { background: 'transparent' }
    //   }}
    // >
    <MainCard
      sx={{ width: '100%' }}
      key={`${data?.Step}-detailCard-main`}
      title={header()}
      id={`${data?.Step}-detailCard-main-id`}
      headerSX={{ backgroundColor: isCompleted ? theme.palette.primary[400] : '#bfbfbf' }}
    >
      <CusListLabelField
        // fields={fields}
        fields={displayDetailFields(data?.Step, fields)}
        data={details}
        fieldKey={'id'}
        xs={6}
        sm={3}
        md={3}
        labelFieldKeyPrefix={'detailCard-labelField'}
      />
    </MainCard>
    // </CardActionArea>
  );
};

export default CusDetailCard;
